<div class="auth-page">
    <div class="auth-card" *ngIf="validKey">
        <div class="auth-brand">
            <mat-icon svgIcon="icon_logo" class="auth-logo"></mat-icon>
        </div>

        <h1 class="auth-title">Imposta Nuova Password</h1>
        <p class="auth-subtitle">Scegli una nuova password e confermala per completare il recupero dell'accesso.</p>

        <form (ngSubmit)="onYesClick()" [formGroup]="formGroup" class="auth-form">
            <mat-form-field class="fo-field">
                <mat-label>Nuova Password</mat-label>
                <input matInput type="password" formControlName="new_password" autocomplete="new-password" required />
                <mat-icon matSuffix>vpn_key</mat-icon>
                <mat-error class="error-message" *ngIf="formGroup.controls['new_password'].hasError('policyNotMatch')"
                    >Lunga 10 con una minuscola, una maiuscola, un numero e un simbolo</mat-error
                >
                <mat-error class="error-message" *ngIf="formGroup.controls['new_password'].hasError('required')"
                    >La nuova password è obbligatoria</mat-error
                >
                <mat-error class="error-message" *ngIf="formGroup.controls['new_password'].hasError('whiteSpace')"
                    >Gli spazi non sono ammessi</mat-error
                >
                <mat-error class="error-message" *ngIf="formGroup.controls['new_password'].hasError('passwordMatch')"
                    >Le password devono corrispondere</mat-error
                >
            </mat-form-field>

            <mat-form-field class="fo-field">
                <mat-label>Conferma Nuova Password</mat-label>
                <input matInput type="password" formControlName="confirm_password" autocomplete="new-password" required />
                <mat-icon matSuffix>vpn_key</mat-icon>
                <mat-error class="error-message" *ngIf="formGroup.controls['confirm_password'].hasError('required')"
                    >La conferma della password è obbligatoria</mat-error
                >
                <mat-error class="error-message" *ngIf="formGroup.controls['confirm_password'].hasError('passwordMatch')"
                    >Le password devono corrispondere</mat-error
                >
            </mat-form-field>

            <button type="submit" class="fo-btn fo-btn--primary fo-btn--block auth-submit" [disabled]="!formGroup.valid">
                CONFERMA
            </button>
        </form>
    </div>

    <div class="auth-card" *ngIf="!validKey">
        <div class="auth-brand">
            <mat-icon class="auth-status-icon">schedule</mat-icon>
        </div>

        <h1 class="auth-title">Link scaduto</h1>
        <p class="auth-subtitle">Il link che ti ha portato a questa pagina è scaduto.</p>

        <a routerLink="/" class="fo-btn fo-btn--primary fo-btn--block auth-submit">Ritorna alla Home.</a>

        <p class="auth-note">Grazie.</p>
    </div>
</div>
